import { Box, ButtonBase } from '@mui/material'
import React from 'react'
import { Icons } from 'utoniq-ui'

import { PostBoxFragment } from '@/clients/utoniq-core/schema'

import { ThumbnailImage } from './ThumbnailImage'

export type ShortVideoProps = {
  post: PostBoxFragment
  onClick: () => void
}

export const ShortVideo = ({ post, onClick }: ShortVideoProps) => {
  const { isAccessible } = post

  if (!post?.resource?.uri) return null
  return (
    <Box
      component={ButtonBase}
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        minHeight: '30vh',
      }}
      onClick={onClick}
    >
      {isAccessible && (
        <ThumbnailImage
          src={post.videoThumbnail?.mediumUri || ''}
          alt="thumbnail"
          withBorderRadius
        />
      )}
      {!isAccessible && (
        <>
          <ThumbnailImage
            src={post.videoThumbnail?.blurUri || ''}
            alt="membership_only"
            withBorderRadius
          />
          <Icons.MembersOnly
            fontSize="xLarge"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: 'white',
            }}
          />
        </>
      )}
    </Box>
  )
}
